require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-omar-c-momentum-agency.json") })
        }
      }, "path---interview-omar-c-momentum-agency");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-omar-c-momentum-agency!./.cache/json/interview-omar-c-momentum-agency.json
// module id = 701
// module chunks = 231608221292675